import createIcon from '../../createIcon';

/**
 * @component @name Person4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMzkgMTUuMDZDMTYuNzEgMTQuMiAxNC41MyAxMy41IDEyIDEzLjVDOS40NyAxMy41IDcuMjkgMTQuMiA1LjYxIDE1LjA2QzQuNjEgMTUuNTcgNCAxNi42IDQgMTcuNzJWMjAuNUgyMFYxNy43MkMyMCAxNi42IDE5LjM5IDE1LjU3IDE4LjM5IDE1LjA2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDEyLjVDMTQuMjEgMTIuNSAxNiAxMC43MSAxNiA4LjVDMTYgNy4xMyAxNiA1IDE2IDVDMTYgNC4xNyAxNS4zMyAzLjUgMTQuNSAzLjVDMTMuOTggMy41IDEzLjUyIDMuNzcgMTMuMjUgNC4xN0MxMi45OCAzLjc3IDEyLjUyIDMuNSAxMiAzLjVDMTEuNDggMy41IDExLjAyIDMuNzcgMTAuNzUgNC4xN0MxMC40OCAzLjc3IDEwLjAyIDMuNSA5LjUgMy41QzguNjcgMy41IDggNC4xNyA4IDVDOCA1IDggNy4xMiA4IDguNUM4IDEwLjcxIDkuNzkgMTIuNSAxMiAxMi41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Person4 = createIcon('Person4', [
  [
    'path',
    {
      d: 'M18.39 15.06C16.71 14.2 14.53 13.5 12 13.5C9.47 13.5 7.29 14.2 5.61 15.06C4.61 15.57 4 16.6 4 17.72V20.5H20V17.72C20 16.6 19.39 15.57 18.39 15.06Z',
      key: '1w3ryu',
    },
  ],
  [
    'path',
    {
      d: 'M12 12.5C14.21 12.5 16 10.71 16 8.5C16 7.13 16 5 16 5C16 4.17 15.33 3.5 14.5 3.5C13.98 3.5 13.52 3.77 13.25 4.17C12.98 3.77 12.52 3.5 12 3.5C11.48 3.5 11.02 3.77 10.75 4.17C10.48 3.77 10.02 3.5 9.5 3.5C8.67 3.5 8 4.17 8 5C8 5 8 7.12 8 8.5C8 10.71 9.79 12.5 12 12.5Z',
      key: 'difc3z',
    },
  ],
]);

export default Person4;
